export const queryWithTimeout = async <T>(
  queryFn: () => Promise<T>,
  timeoutMs = 10000,
): Promise<T | 'timeout'> => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const timeout = new Promise<'timeout'>((resolve) => {
    timer = setTimeout(() => resolve('timeout'), timeoutMs);
  });

  try {
    const queryPromise = queryFn().catch(() => 'timeout' as const);
    const result = await Promise.race([queryPromise, timeout]);
    return result;
  } finally {
    if (timer) clearTimeout(timer);
  }
};
